import * as angular from 'angular';

import { ComponentDefinition, ThermoPackage } from '../../../models/';
import { IThermoPackageService, ILoggerService } from '../../../services/';

class ThermoPackageDetailsController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    thermoPackage: ThermoPackage;
    itemName: string;

    static $inject = ['$stateParams', 'thermoPackageService', 'loggerService'];

    constructor(
        private _$stateParams: angular.ui.IStateParamsService,
        private _thermoPackageService: IThermoPackageService,
        private _loggerService: ILoggerService
    ) {
    }

    $onInit() {
        if (this.itemName === undefined) {
            this.itemName = this._$stateParams.name;
        }

        // get the package by its name
        if (this.itemName) {
            this.isLoading = true;
            this._thermoPackageService
                .getByName(this.itemName)
                .then(data => this.thermoPackage = data.packageInformation)
                .catch(r => this._loggerService.logError(r?.message ?? r))
                .finally(() => this.isLoading = false);
        }
    }
}

export const wtThermoPackageDetails: ComponentDefinition = {
    componentId: 'wtThermoPackageDetails',
    controller: ThermoPackageDetailsController,
    template: require('./thermoPackageDetails.component.html'),
    controllerAs: 'vm',
    bindings: {
        itemName: '<?'
    }
};
